import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { CenteredCircularProgress } from '../../../common/CenteredCircularProgress';
import { NoResults } from '../../shared/NoResults';
import { SearchEmptyState } from './SearchEmptyState';

interface SearchResultsContentProps {
  isLoading: boolean;
  hasSearched: boolean;
  noResults: boolean;
  emptyState?: ReactNode;
  children: ReactNode;
}

export const SearchResultsContent = ({
  isLoading,
  hasSearched,
  noResults,
  emptyState,
  children,
}: SearchResultsContentProps) => (
  <Stack sx={{ gap: 2, height: '100%', width: '100%', overflow: 'auto' }}>
    {isLoading && <CenteredCircularProgress />}

    {!isLoading && !hasSearched && (emptyState ?? <SearchEmptyState />)}

    {!isLoading && hasSearched && noResults && (
      <Box pr={1} pl={2}>
        <NoResults />
      </Box>
    )}

    {!isLoading && hasSearched && !noResults && children}
  </Stack>
);
